// src/services/commentReports.js
import { adminPatch } from '../config/api';

const encodeId = (value) => encodeURIComponent(value);

/**
 * Met à jour le statut d'un signalement de commentaire.
 * Attendu côté backend : PATCH /api/admin/comment-reports/{reportId}/status
 * Body JSON : { status: "NEW" | "REVIEWING" | "RESOLVED" | "DISMISSED", note?: string | null }
 */
export const updateCommentReportStatus = (reportId, payload = {}) =>
    adminPatch(`/comment-reports/${encodeId(reportId)}/status`, payload);

/**
 * Applique une action modératrice sur le commentaire signalé.
 * Attendu côté backend : PATCH /api/admin/comment-reports/{reportId}/comment
 * Body JSON : { action: "REMOVE" | "HIDE" | "WARN_AUTHOR", note?: string | null }
 */
export const moderateReportedComment = (reportId, payload = {}) =>
    adminPatch(`/comment-reports/${encodeId(reportId)}/comment`, payload);

export const COMMENT_MODERATION_ACTIONS = {
    REMOVE: 'REMOVE',
    HIDE: 'HIDE',
    WARN_AUTHOR: 'WARN_AUTHOR',
};
